import { InstantSearch, Configure } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch'
import { node } from 'prop-types'

import { isAgentApp } from '@/utils'

import { SEARCH } from '../constants'

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_API_KEY
)

const searchClient = {
  // Avoid initial blank searches, min search for 2 characters
  search(requests) {
    const shouldSearch = requests.some(({ params: { query } }) => {
      return query.length >= SEARCH.MIN_CHARS
    })

    if (shouldSearch) {
      return algoliaClient.search(requests)
    }

    return Promise.resolve({
      results: [{ hits: [] }],
    })
  },
}

const AlgoliaProvider = ({ children }) => {
  const facetFilters = ['hidden:false']

  if (isAgentApp) {
    facetFilters.push('product:-helpdesk')
  }

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
    >
      <Configure hitsPerPage={SEARCH.LIMIT} facetFilters={facetFilters} />
      {children}
    </InstantSearch>
  )
}

AlgoliaProvider.propTypes = {
  children: node,
}

export default AlgoliaProvider
